import { useRouter } from 'next/router'
import { useCategoriesContext } from '~/src/contexts'
import { SectionHeader } from '~/src/components/shared'
import { PostTable } from '~/src/components/post'
import { CONNECT_JOBINFO_CATEGORY } from '~/src/const'

interface Row {
	id: string
	link: string
	no: string 
	title: string
	publishedAt: string
}

export function JobInfo() {
  const router = useRouter()
  const { categories } = useCategoriesContext()
  const jobInfoCategory =  categories.find(category => category?.categoryId === CONNECT_JOBINFO_CATEGORY)

  const handlePageChange = (page: number) => {
    router.push({ 
      pathname: router.pathname,
      query: { page }
    }, undefined, { shallow: true })
  }

  if (!jobInfoCategory) return null

  return (
    <div>
      <SectionHeader 
        title={jobInfoCategory.name}
        variant="primary"
        description={jobInfoCategory.description ?? ''}
      />
      <PostTable 
        categoryId={CONNECT_JOBINFO_CATEGORY}
        generateLink={(post) => `${router.pathname}/${post.id}`}		
        onPageChange={handlePageChange}
      />
    </div>
  )
}